import React from 'react'
import { MaterialSymbol } from '../../../components/MaterialSymbol'
import { SEED_MIX_TYPE } from '../types/SeedOrderFormType'
import { colors } from '../../../themes/colors'

const MixTypeIcon = ({ type }: { type: string | undefined }) => {
  if (!type) return null

  const iconType = type === SEED_MIX_TYPE.CUSTOM ? 'wysiwyg' : 'inventory_2'

  return (
    <MaterialSymbol sx={{ marginRight: '8px', color: colors.primary500 }}>
      {iconType}
    </MaterialSymbol>
  )
}

export default MixTypeIcon
